import ClarityScript from './ClarityScript';

export default ClarityScript;
